import { render, staticRenderFns } from "./UnidadesRegionais.vue?vue&type=template&id=1e49d6c4"
import script from "./UnidadesRegionais.vue?vue&type=script&lang=js"
export * from "./UnidadesRegionais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports